import React, { Component } from 'react';
import './A3.css';

class A3 extends Component{
    render(){
        return(    
        <div className="campoA3"style={{
            backgroundImage: 'url(' + require('../../../assets/texturas/gif-dimen1.gif') + ')'}} >{this.props.children}
        </div>
        )
    }

}

export default A3;